import { Component } from '@angular/core';
import { HeroComponent } from '../../shared/hero/hero.component';
import { FirestoreService } from '../../../services/firestore/firestore.service';

@Component({
  selector: 'app-privacy',
  imports: [HeroComponent],
  templateUrl: './privacy.component.html',
  styleUrl: './privacy.component.css'
})
export class PrivacyComponent {
  companyInfo:any;
  constructor(
        private firestoreService: FirestoreService
    
  ){}
  ngOnInit(){
    this.loadCompanyInfo();
  }
  loadCompanyInfo() {
    this.firestoreService.getById('companyInfo', 'main').subscribe({
      next: (info) => {
        this.companyInfo = info || null;
        console.log(this.companyInfo.email)
      },
    });
  }
}
